import React from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { formatError, reportError } from "../../../../helpers/error-helper";

interface WeightEventsErrorBoundaryProps {
  children: React.ReactNode;
}

const Fallback = ({ resetError }: { resetError: () => void }) => {
  const { t } = useTranslation(["shipmentModal"]);
  return (
    <div className="shipment-dialog__shipment-stat">
      <div>{t("shipmentModal:totalWeight")}</div>
      <div
        className="flex gap-1 items-center "
        // style={{ color: "var(--error-500)" }}
      >
        {t("shipmentModal:failedToLoad")}
      </div>
    </div>
  );
};

const WeightEventsErrorBoundary = ({
  children,
}: WeightEventsErrorBoundaryProps) => {
  const onError: Sentry.ErrorBoundaryProps["onError"] = (
    error,
    componentStack,
    eventId
  ) => {
    reportError({ err: formatError(error), componentStack, eventId });
  };
  return (
    <Sentry.ErrorBoundary
      onError={onError}
      fallback={({ resetError }) => <Fallback resetError={resetError} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default WeightEventsErrorBoundary;
